import React from 'react';
import { Send, PenLine, Smartphone, ShieldCheck } from 'lucide-react';
import { siteConfig } from '../../data/siteConfig';
const items = [{
  icon: Send,
  label: 'Descarga inmediata'
}, {
  icon: PenLine,
  label: '100% editable'
}, {
  icon: Smartphone,
  label: 'Úsalo desde el celular'
}, {
  icon: ShieldCheck,
  label: `Garantía de ${siteConfig.guaranteeDays} días`
}];
export function TrustStrip() {
  return <div className="border-b border-line bg-cream" data-id="element-268" data-mp="36kmnzpku0l3i">
      <ul className="mx-auto flex max-w-[1120px] flex-wrap justify-center gap-x-10 gap-y-3.5 px-5 py-5" data-id="element-269" data-mp="36jtmp44n6nsr">
        {items.map(({
        icon: Icon,
        label
      }) => <li key={label} className="flex items-center gap-2.5 font-display text-[15px] font-semibold text-forest" data-id="element-270" data-mp="3gcse0triwsg2">
            <Icon className="h-5 w-5 text-tangerine" aria-hidden="true" data-id="element-271" data-mp="3l9r6l7vjgrc5" />
            {label}
          </li>)}
      </ul>
    </div>;
}